import './index.scss';
import 'components/select';
import { errorInterpreter } from 'utils/error_interpreter';

const errorMapping = {
  1: {
    title: 'O enunciado ou as alternativas estão diferentes da prova oficial?',
    subtitle:
      'Se o enunciado ou as alternativas estiverem diferentes do conteúdo oficial, vamos analisar e corrigir conforme a prova liberada pela banca.',
    btnLabel: 'Reportar erro'
  },
  2: {
    title: 'Esse gabarito está diferente do oficial divulgado pela banca?',
    subtitle:
      'Caso o gabarito oficial, divulgado pela banca, seja outro, faremos a correção após análise e confirmação.',
    btnLabel: 'Reportar erro'
  },
  3: {
    title: 'A disciplina ou assunto desta questão está incorreto?',
    subtitle:
      'Se você identificou que esta questão pertence a outra disciplina ou assunto, vamos revisar e ajustar em conformidade com a orientação dos professores.',
    btnLabel: 'Sugerir nova classificação'
  },
  4: {
    title: 'Esta questão foi oficialmente anulada pela banca?',
    subtitle:
      'Se a banca responsável pela prova anulou oficialmente a questão, faremos a correção após verificação dos documentos oficiais.',
    btnLabel: 'Reportar anulação oficial'
  },
  5: {
    title: 'Esta questão está desatualizada ou fora de contexto atual?',
    subtitle:
      'Se houve mudanças legais ou contextuais que invalidam o conteúdo, realizaremos a atualização após análise das fontes oficiais ou referências recentes.',
    btnLabel: 'Reportar conteúdo desatualizado'
  },
  6: {
    title:
      'Esta questão é duplicada e possui enunciado e alternativas idênticas?',
    subtitle:
      'Se a questão tiver enunciado, alternativas e gabarito iguais a outra existente, unificaremos as informações e evitaremos duplicidades.',
    btnLabel: 'Reportar questão duplicada'
  }
};

class QuestionNotifyTab {
  constructor($context) {
    this.$context = $context;
    this.$createForm = $('.q-create-form', this.$context);
    this.$errorSelectionScreen = $('#error-selection', this.$context);
    this.$errorDetailsScreen = $('#error-details', this.$context);
    this.$backButton = $('#back-button', this.$context);
    this.$enableSubmitCheckbox = $('#enable-submit', this.$context);
    this.$submitButton = $('#submit-btn', this.$context);
    this.isSubmitting = false;
    this.handleErrorTypeChange();
    this.bindEvents();
  }

  createNotification() {
    const data = this.$createForm.serializeObject();
    const $description = document.getElementById('description');

    if ($description.value.trim() === '') {
      $description.setCustomValidity($description.getAttribute('title'));
      $description.reportValidity();
      return;
    }

    Thor.QuestionError.create({}, { data })
      .then(() => {
        this.isSubmitting = false;

        const questionId = this.$createForm
          .find('input[name="question_error[question_id]"]')
          .val();

        if (window.Intercom) {
          window.Intercom('update', {
            'Último recurso com erro notificado': 'Questão',
            'Informação do recurso com erro notificado': String(questionId)
          });
        }

        this.$createForm.clearForm().trigger('ajax:success').clearForm();
      })
      .catch(({ response }) => {
        this.isSubmitting = false;
        this.$submitButton.prop(
          'disabled',
          !this.$enableSubmitCheckbox.prop('checked')
        );
        errorInterpreter({
          message: 'Ops! Não foi possível criar a notificação nesse momento!',
          response
        });
        this.$createForm.trigger('ajax:error');
      });
  }

  handleErrorTypeChange() {
    $('input[name="question_error[type]"]').each((_, radio) => {
      $(radio).on('change', () => {
        const errorText = errorMapping[radio.value];
        $('h2.error-description').text(errorText?.title);
        $('p.error-description').text(errorText?.subtitle);

        this.$submitButton.text(errorText?.btnLabel);
        this.showErrorDetails();
      });
    });
  }

  showErrorDetails() {
    this.$errorSelectionScreen.addClass('hidden');
    this.$errorDetailsScreen.removeClass('hidden');

    this.$backButton.on('click', () => {
      this.$errorSelectionScreen.removeClass('hidden');
      this.$errorDetailsScreen.addClass('hidden');
      this.resetForm();
    });

    this.$enableSubmitCheckbox.on('change', () => {
      this.$submitButton.prop(
        'disabled',
        !this.$enableSubmitCheckbox.prop('checked')
      );
    });
  }

  resetForm() {
    const selectedRadio = $('input[name="question_error[type]"]:checked');

    if (selectedRadio.length) {
      selectedRadio.prop('checked', false);
    }

    this.$enableSubmitCheckbox.prop('checked', false);
    this.$submitButton.prop('disabled', true);
  }

  bindEvents() {
    this.$createForm
      .ajaxForm()
      .lazyReady()
      .on('submit', e => {
        e.preventDefault();

        if (this.isSubmitting) {
          return false;
        }
        this.isSubmitting = true;
        this.$submitButton.prop('disabled', true);
        this.createNotification();
        return false;
      });
  }
}

(function () {
  'use strict';

  $(document)
    .off('componentLoaded:questions/question_notify')
    .on('componentLoaded:questions/question_notify', (e, data) => {
      $('.q-select-input', data.context).qselect();
      new QuestionNotifyTab(data.context);
    });
})(jQuery);
